import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-697a623a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "order-details" };
const _hoisted_2 = { class: "order-details__info" };
const _hoisted_3 = { class: "order-details__products" };
const _hoisted_4 = { class: "order-details__section-title" };
const _hoisted_5 = { class: "product-item" };
const _hoisted_6 = { class: "product-item__info" };
const _hoisted_7 = { class: "product-item__image" };
const _hoisted_8 = { class: "product-item__details" };
const _hoisted_9 = { class: "product-item__price" };
import SkeletonLoader from '@/components/_atoms/SkeletonLoader.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CustomerOrderDetailsSkeleton',
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_el_divider = _resolveComponent("el-divider");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", null, [
                        _createVNode(SkeletonLoader, {
                            height: "25px",
                            width: "275px"
                        }),
                        _createVNode(SkeletonLoader, {
                            height: "25px",
                            width: "275px"
                        }),
                        _createVNode(SkeletonLoader, {
                            height: "25px",
                            width: "275px"
                        })
                    ]),
                    _createElementVNode("div", null, [
                        _createVNode(SkeletonLoader, {
                            height: "25px",
                            width: "275px"
                        }),
                        _createVNode(SkeletonLoader, {
                            height: "25px",
                            width: "275px"
                        })
                    ])
                ]),
                _createVNode(_component_el_divider),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(SkeletonLoader, {
                            height: "25px",
                            width: "275px"
                        })
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                                _createVNode(SkeletonLoader, {
                                    height: "80px",
                                    width: "80px"
                                })
                            ]),
                            _createElementVNode("div", null, [
                                _createVNode(SkeletonLoader, {
                                    height: "20px",
                                    width: "200px"
                                }),
                                _createElementVNode("div", _hoisted_8, [
                                    _createVNode(SkeletonLoader, {
                                        height: "15px",
                                        width: "120px"
                                    }),
                                    _createVNode(SkeletonLoader, {
                                        height: "15px",
                                        width: "140px"
                                    }),
                                    _createVNode(SkeletonLoader, {
                                        height: "15px",
                                        width: "130px"
                                    }),
                                    _createVNode(SkeletonLoader, {
                                        height: "15px",
                                        width: "110px"
                                    })
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                            _createVNode(SkeletonLoader, {
                                height: "20px",
                                width: "100px"
                            }),
                            _createVNode(SkeletonLoader, {
                                height: "15px",
                                width: "80px"
                            })
                        ])
                    ])
                ])
            ]));
        };
    }
});
